export const CirroTableColumns = [
  { label: 'Id', field: 'Id' },
  { label: 'Date', field: 'Datetime' },
  { label: 'ID Label', field: 'OrderId' },
  { label: 'State', field: 'State' },
  { label: 'Post Code', field: 'Postcode' },
  { label: 'Reference Code', field: 'ReferenceNo' },
  { label: 'Status' },
  { label: 'Link' },
];
